var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticStyle:{"z-index":"1"},attrs:{"width":_vm.width,"outlined":""}},[_c('v-card-text',[_c('div',[_vm._v(_vm._s(_vm.text))]),_c('v-divider'),_c('div',[_vm._v("("+_vm._s(_vm.totalUnit)+" Units)")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }